import React from "react";
import { CONTATO } from "@/data/cabanas";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";

export default function Contato() {
    return (
        <div className="bg-cdb-cream">
            <section className="pt-20 pb-12 sm:pt-28 sm:pb-16 leaf-pattern">
                <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
                    <span className="text-cdb-gold text-sm font-bold uppercase tracking-widest">
                        Fale conosco
                    </span>
                    <h1
                        data-testid="contato-title"
                        className="text-4xl sm:text-5xl lg:text-6xl font-bold text-cdb-forest mt-3 mb-4 leading-tight"
                    >
                        Contato
                    </h1>
                    <p className="text-cdb-earth/80 text-base sm:text-lg leading-relaxed">
                        Estamos prontos para receber você. Entre em contato pelos canais abaixo.
                    </p>
                </div>
            </section>

            <section className="pb-24">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-8">
                    <div className="space-y-4">
                        <div className="bg-white border border-cdb-sand rounded-3xl p-8">
                            <div className="flex items-start gap-4">
                                <span className="w-12 h-12 rounded-2xl bg-cdb-forest/10 text-cdb-forest flex items-center justify-center flex-shrink-0">
                                    <MapPin className="w-6 h-6" />
                                </span>
                                <div>
                                    <h3 className="text-lg font-bold text-cdb-forest mb-1">Endereço</h3>
                                    <p className="text-sm text-cdb-earth leading-relaxed">{CONTATO.endereco}</p>
                                </div>
                            </div>
                        </div>

                        <a
                            href={`https://wa.me/${CONTATO.whatsapp}`}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="contato-whatsapp"
                            className="block bg-white border border-cdb-sand rounded-3xl p-8 hover:border-cdb-gold transition-colors"
                        >
                            <div className="flex items-start gap-4">
                                <span className="w-12 h-12 rounded-2xl bg-cdb-forest/10 text-cdb-forest flex items-center justify-center flex-shrink-0">
                                    <MessageCircle className="w-6 h-6" />
                                </span>
                                <div>
                                    <h3 className="text-lg font-bold text-cdb-forest mb-1">WhatsApp / Telefone</h3>
                                    <p className="text-sm text-cdb-earth">{CONTATO.telefone}</p>
                                    <p className="text-xs text-cdb-gold font-bold mt-1">Clique para abrir conversa →</p>
                                </div>
                            </div>
                        </a>

                        <a
                            href={`mailto:${CONTATO.email}`}
                            data-testid="contato-email"
                            className="block bg-white border border-cdb-sand rounded-3xl p-8 hover:border-cdb-gold transition-colors"
                        >
                            <div className="flex items-start gap-4">
                                <span className="w-12 h-12 rounded-2xl bg-cdb-forest/10 text-cdb-forest flex items-center justify-center flex-shrink-0">
                                    <Mail className="w-6 h-6" />
                                </span>
                                <div>
                                    <h3 className="text-lg font-bold text-cdb-forest mb-1">E-mail</h3>
                                    <p className="text-sm text-cdb-earth">{CONTATO.email}</p>
                                </div>
                            </div>
                        </a>

                        <div className="bg-white border border-cdb-sand rounded-3xl p-8">
                            <div className="flex items-start gap-4">
                                <span className="w-12 h-12 rounded-2xl bg-cdb-forest/10 text-cdb-forest flex items-center justify-center flex-shrink-0">
                                    <Clock className="w-6 h-6" />
                                </span>
                                <div>
                                    <h3 className="text-lg font-bold text-cdb-forest mb-1">Horários</h3>
                                    <p className="text-sm text-cdb-earth">Check-in: 15:00</p>
                                    <p className="text-sm text-cdb-earth">Check-out: 12:00</p>
                                </div>
                            </div>
                        </div>

                        <div className="text-xs text-cdb-earth/60 pt-2">CNPJ: {CONTATO.cnpj}</div>
                    </div>

                    <div className="rounded-3xl overflow-hidden border border-cdb-sand h-[500px] lg:h-auto">
                        <iframe
                            data-testid="contato-map"
                            title="Mapa Cabanas da Barra"
                            src="https://www.google.com/maps?q=Estr.+Roberto+Burle+Marx,+2069+-+Barra+de+Guaratiba,+Rio+de+Janeiro&output=embed"
                            className="w-full h-full min-h-[500px]"
                            loading="lazy"
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}
